var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-cental"},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("ADMINISTRACION DE MISTY ORACLE")])])}]

export { render, staticRenderFns }